// Products + brands. Kept minimal — the merchandising rules live in the
// backend enum and in dealer_validation.
import React from 'react';
import { ChipMultiField, ListField, SwitchField } from './fields';
import { PRODUCT_KINDS } from './constants';

export default function ProductsSection({ value, onChange }) {
  const set = (key) => (v) => onChange({ ...value, [key]: v });
  return (
    <div className="space-y-4">
      <ChipMultiField
        label="Products sold"
        value={value.products_sold}
        onChange={set('products_sold')}
        options={PRODUCT_KINDS}
      />
      <ListField
        label="Brands sold"
        value={value.brands_sold}
        onChange={set('brands_sold')}
        placeholder="Honda, Yamaha, Polaris"
      />
      <SwitchField
        label="Allow cross-sell"
        description="Agent may suggest related product categories."
        value={value.allow_cross_sell}
        onChange={set('allow_cross_sell')}
      />
    </div>
  );
}
